<template>
    <div id="wrapper">
        <Background></Background>
        <div class="link-container container-fluid">
            <LinkTable/>

            <ServerInfo class="server-info"/>
            <LicenceFooter />
        </div>

        <Logo></Logo>
    </div>
</template>

<script>
    import Background from './components/Background.vue'
    import Logo from "./components/Icon";
    import LinkTable from "./components/LinkTable";
    import ServerInfo from "./components/ServerInfo";
    import LicenceFooter from "./components/LicenceFooter";

    export default {
        name: 'App',
        components: {
            LicenceFooter,
            ServerInfo,
            LinkTable,
            Logo,
            Background
        }
    }
</script>

<style>
    /*This is just a full screen wrapper for the app container*/
    #wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }

    /**
    A little space between the links and the servere info
     */
    .server-info {
        margin: 3.5rem 0 0 0;
    }

    /**
    A little space between the top of the website and the references
     */
    .link-container {
        padding: 22rem 0 0;
    }

    /**
    Responsive for the links. This will remove the image from Server IP and have the logo act as it
     */
    @media only screen and (max-height: 850px) and (min-width: 576px){
        .link-container {
            padding: 13rem 0 0;
        }

        .remove-small-screen img {
            visibility: hidden;
        }
    }

    /**
    We all hate margins.
     */
    body {
        margin: 0;
    }
</style>
